import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';
import Upperbox from '../components/Upperbox';

export const Bookkeeping = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Upperbox />
      <NavBar />
      <div className='tax-page'>
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">Accounting and Bookkeeping Services</h1>
            <Link to="/businessservicespage" className="tax-notification-body">Go Back</Link>
          </div>
        </div>

        <div className='tax-content-container'>
          <h1 className='tax-section-title'>
            Professional Accounting and Bookkeeping Services at Sumukha Tax Filers.
          </h1>
          <p className='tax-section-description'>
            Effective accounting and bookkeeping are essential for your business's success. At Sumukha Tax Filers., we offer comprehensive accounting and bookkeeping services tailored to meet the unique needs of your business. Our experienced Certified Public Accountants (CPAs) and Enrolled Agents (EAs) are here to ensure your financial records are accurate, organized, and compliant with all regulatory requirements.
          </p>
          <h2 className='tax-subheading'>Why Choose Sumukha Tax Filers. for Accounting and Bookkeeping?</h2>
          <ul className='tax-section-description'>
            <li><strong>Expertise:</strong> Our team consists of highly qualified professionals with extensive knowledge of accounting principles and practices. We understand the intricacies of financial reporting and tax compliance, enabling us to provide top-notch services.</li>
            <li><strong>Customized Solutions:</strong> We recognize that every business is unique. We tailor our accounting and bookkeeping services to meet your specific industry requirements and business objectives.</li>
            <li><strong>Focus on Growth:</strong> By outsourcing your accounting and bookkeeping needs to us, you can concentrate on what you do best—growing your business. We handle the financial details, so you can focus on your core operations.</li>
          </ul>
          <h2 className='tax-subheading'>Our Accounting and Bookkeeping Services</h2>
          <p className='tax-section-description'>
            At Sumukha Tax Filers., we utilize popular accounting software to streamline our processes and enhance accuracy. Our services include:
          </p>
          <ol className='tax-section-description'>
            <li><strong>Bookkeeping Setup:</strong> We will set up your bookkeeping system using leading accounting software such as QuickBooks, Xero, or FreshBooks. This ensures your financial transactions are organized from the start, making it easier to manage your finances.</li>
            <li><strong>Ongoing Bookkeeping:</strong> We maintain accurate records of all financial transactions, including managing accounts payable and receivable, bank reconciliations, and payroll processing.</li>
            <li><strong>Financial Statement Preparation:</strong> Using your chosen accounting software, we prepare detailed financial statements, including balance sheets, income statements, and cash flow statements, to provide you with insights into your business's financial health.</li>
            <li><strong>Monthly and Year-End Closings:</strong> Our team conducts regular monthly and year-end closings to ensure that your financial records are accurate and compliant with accounting standards.</li>
            <li><strong>Tax Compliance and Planning:</strong> We assist with tax compliance by ensuring that all financial records are accurately reported and that tax obligations are met. Our tax planning strategies can help minimize your tax liability.</li>
            <li><strong>Budgeting and Forecasting:</strong> We help you create budgets and financial forecasts using your accounting software, guiding your business decisions and ensuring that you are prepared for future growth and challenges.</li>
            <li><strong>Account Reconciliation:</strong> We provide thorough account reconciliation services to ensure that your financial statements match your bank records, identifying any discrepancies promptly.</li>
            <li><strong>Consulting Services:</strong> Our CPAs and EAs are available for consulting on various financial matters, including business strategy, financial analysis, and improving operational efficiency.</li>
          </ol>
          <h2 className='tax-subheading'>Get Started Today</h2>
          <p className='tax-section-description'>
            At Sumukha Tax Filers., we are committed to providing high-quality accounting and bookkeeping services that help your business thrive. With our team of expert CPAs and EAs, you can trust that your financial records are in good hands. Contact us today to schedule a consultation and discover how we can support your business's financial success!
          </p>
        </div>
      </div>
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};
export default Bookkeeping;